export const FETCH_PLUGIN_SETTINGS = 'fetchPluginSettings';
export const CREATE_GIFTCARD = 'createGiftcard';
export const CREATE_GIFTCARD_MULTIPLE_REQUEST = 'createGiftcardMultipleRequest';
export const FETCH_GIFTCARD_SESSION = 'fetchGiftcardSession';